import React, { useState } from 'react'
import _ from 'lodash'
import { useIntl } from 'react-intl'
import { Box } from '@mui/system'
import { Button } from '@mui/material'
import { ChevronRightRounded, SmartDisplayRounded } from '@mui/icons-material'
import CustomLinearProgress from '../../../../components/muiComponents/customLinearProgress'
import { QuestionState } from '../../../../features/types'
import VideoExplanationDialog from './VideoExplanationDialog'
import ResultOption from './ResultOption'
import { tone, ui } from '../../../../utils/uiTokens'

interface Props {
    index: number
    question: QuestionState
}

const ResultQuestion: React.FC<Props> = ({ question = null, index }) => {
    const [openDialog, setOpenDialog] = useState(false)
    const { formatMessage } = useIntl()

    const handleClose = () => {
        setOpenDialog(false)
    }

    const isCorrect = _.some(
        question.answers,
        (answer) => answer.correct && answer.correct === answer.isChecked,
    )

    const styles = {
        content: {
            display: 'flex',
            mb: 2,
        },
        wrapper: {
            border: `1px solid ${ui.border}`,
            borderRadius: '8px',
            p: 3,
            mb: 3,
        },
        message: {
            mb: 2,
            fontWeight: 600,
            fontSize: '15px',
            color: isCorrect ? tone.ok.text : tone.bad.text,
        },
        flexCenter: {
            display: 'flex',
            alignItems: 'center',
        },
        percentage: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'end',
        },
        progress: {
            backgroundcolor:
                question.percentage <= 50
                    ? tone.bad.bg
                    : question.percentage <= 80
                    ? tone.warn.bg
                    : tone.ok.bg,
            barbackgroundcolor:
                question.percentage <= 50
                    ? tone.bad.text
                    : question.percentage <= 80
                    ? tone.warn.text
                    : tone.ok.text,
        },
    }

    return (
        <Box sx={styles.wrapper}>
            <Box sx={styles.content}>
                {index + 1}.{' '}
                <Box dangerouslySetInnerHTML={{ __html: question.content }} />
            </Box>

            <Box sx={{ width: '100%', mb: 3 }}>
                <Box sx={styles.percentage}>{question.percentage + ' %'}</Box>

                <CustomLinearProgress
                    variant="determinate"
                    value={question.percentage}
                    {...styles.progress}
                />
            </Box>

            <Box>
                {question.answers.map((answer, index) => (
                    <ResultOption
                        key={answer.id}
                        index={index}
                        answer={answer}
                        selected={answer.isChecked}
                    />
                ))}
            </Box>

            <Box sx={{ display: 'flex', mt: 2 }}>
                <Button
                    variant="outlined"
                    startIcon={<SmartDisplayRounded />}
                    endIcon={<ChevronRightRounded />}
                    sx={{ marginLeft: 'auto' }}
                    onClick={() => setOpenDialog(true)}
                >
                    {formatMessage({ id: 'watchVideoSolution' })}
                </Button>
            </Box>

            <VideoExplanationDialog
                question={question}
                open={openDialog}
                handleClose={handleClose}
                confirmAction={handleClose}
            />
        </Box>
    )
}

export default ResultQuestion
